import axios from 'axios';
import { isEmpty } from 'radash';

import { useDataModel } from '@/hooks/useDataModel';
import { logger } from '@/services/logger';
import { restUrl } from '@/services/utils';
import { AdditionalCategory, DataModelAttribute, Item } from '@/types/DataModel';

const useAdditionalCategoryAttributes = () => {

    const { dataModel } = useDataModel();

    const getAdditionalCategoryAttributes = async (item: Item) => {

        if (!dataModel) {
            return;
        }

        // Get the used additional modules and the additional categories values out of
        // the item, if any is filled.
        const itemAdditionalCategoriesPerModule = dataModel.getItemAdditionalCategories(item);

        logger.debug('useAdditionalCategoryAttributes: itemAdditionalCategoriesPerModule', itemAdditionalCategoriesPerModule);

        if (isEmpty(itemAdditionalCategoriesPerModule)) {
            // No additional category attributes are used in the item, we have nothing to do.
            return;
        }

        const missingCategories = dataModel.getMissingAdditionalCategories(itemAdditionalCategoriesPerModule);
        logger.debug('useAdditionalCategoryAttributes: missingCategories', missingCategories);

        // If the dataModel object don't have the additional categories used in the item
        // we have to load them from the backend and add them to the dataModel map.
        if (!isEmpty(missingCategories)) {
            const missingAdditionalCategoriesResponse = await axios.post(restUrl('datamodel/additional/categories'), missingCategories);
            const missingAdditionalCategories = missingAdditionalCategoriesResponse.data as Record<string, AdditionalCategory[]>;
            dataModel.addAdditionalCategories(missingAdditionalCategories);
        }

        // Now that we are sure the dataModel map has all the used additional modules and categories in the item, we
        // should ensure that the data model map has the additional attributes.
        const missingAttributes = dataModel.getMissingAdditionalAttributes(itemAdditionalCategoriesPerModule);
        if (!isEmpty(missingAttributes)) {
            const missingAttributesResponse = await axios.post(restUrl('datamodel/additional/attributes'), missingAttributes);
            const missingAttributesPerModule = missingAttributesResponse.data as Record<string, DataModelAttribute[]>;
            dataModel.addAdditionalAttributes(missingAttributesPerModule);
        }

        // Now that we ensured everything is loaded into the dataModel map, we are done.
    };

    return { getAdditionalCategoryAttributes };
};

export { useAdditionalCategoryAttributes };
